import { useState, useEffect, useRef } from "react";
import "./App.css";

// Assets
const LOGO_URL = "https://customer-assets.emergentagent.com/job_6fa49454-f216-41c4-ad6c-e1d8bfe3a11e/artifacts/1wasgcls_72bc90c6-d374-4fd6-bbae-b07bd26cd19b.jpeg";
const MASCOT_URL = "https://customer-assets.emergentagent.com/job_6fa49454-f216-41c4-ad6c-e1d8bfe3a11e/artifacts/nfwqyisr_ae0cd023-034e-4d51-b06f-2e3454bac50f.jpeg";
const RESULTADO_IMG = "https://customer-assets.emergentagent.com/job_general-command-ops/artifacts/ui4vp8c4_ChatGPT%20Image%20Mar%2027%2C%202026%2C%2002_01_36%20AM%281%29.png";

// Background Music - MP4 as audio only
const BG_MUSIC_URL = "https://customer-assets.emergentagent.com/job_general-command-ops/artifacts/ft0fulac_WhatsApp%20Video%202026-03-27%20at%2002.47.05.mp4";

// WhatsApp
const WHATSAPP = "5521972232170";
const WHATSAPP_URL = `https://wa.me/${WHATSAPP}`;
const LOJA_URL = "https://www.suplementosmaisbaratos.com.br";
const CUPOM = "SMB10OFF";

// Admin credentials
const ADMIN_USER = "admin";
const ADMIN_PASS = "0972044108A!bc";

// Redirect timer (33 seconds)
const REDIRECT_TIMER = 33000;

// Analytics
const Analytics = {
  track: (event, data = {}) => {
    const events = JSON.parse(localStorage.getItem('md_analytics') || '[]');
    events.push({ event, data, timestamp: new Date().toISOString(), session: sessionStorage.getItem('md_session') || 'unknown' });
    localStorage.setItem('md_analytics', JSON.stringify(events));
  },
  getAll: () => JSON.parse(localStorage.getItem('md_analytics') || '[]'),
  clear: () => localStorage.removeItem('md_analytics'),
  getSummary: () => {
    const events = Analytics.getAll();
    const sessions = [...new Set(events.map(e => e.session))];
    return {
      total_visits: events.filter(e => e.event === 'page_view').length,
      unique_sessions: sessions.length,
      play_clicks: events.filter(e => e.event === 'click_play').length,
      missions_started: events.filter(e => e.event === 'mission_start').length,
      missions_completed: events.filter(e => e.event === 'mission_complete').length,
      whatsapp_clicks: events.filter(e => e.event === 'whatsapp_click').length,
      bluetooth_game: events.filter(e => e.event === 'bluetooth_game').length
    };
  }
};

if (!sessionStorage.getItem('md_session')) {
  sessionStorage.setItem('md_session', 'sess_' + Math.random().toString(36).substr(2, 9));
}

// Audio options for Bluetooth hack
const AUDIO_OPTIONS = [
  { 
    id: 1, 
    nome: "Chamado no Rádio", 
    texto: "Alô parceiro, é o comando... chegou encomenda na base...", 
    icon: "📻",
    resultado: {
      titulo: "ELE OUVIU O CHAMADO!",
      descricao: "Seu amigo escuta o chamado pelo rádio dele, anda um pouco confuso e liga o sistema de alerta!",
      visual: "radio_alert"
    }
  },
  { 
    id: 2, 
    nome: "Pergunta Técnica", 
    texto: "Sistema detectou interferência... Confirme protocolo: Bluetooth ou Rádio AM/FM?", 
    icon: "🔧",
    resultado: {
      titulo: "JAMMER CONFUNDE O MOTORISTA!",
      descricao: "Ele para, olha pro painel confuso e fica tentando entender se o protocolo de comunicação é Bluetooth ou Rádio AM/FM...",
      visual: "confused"
    }
  },
  { 
    id: 3, 
    nome: "A Piada", 
    texto: "ATENÇÃO: Tem um cara muito feio atrás do seu carro... ah não, é você no retrovisor!", 
    icon: "😂",
    resultado: {
      titulo: "KKKKKKKK ELE SAIU CORRENDO!",
      descricao: "Seu amigo sai acelerando de carro enquanto você fica parado rindo da piada!",
      visual: "laughing"
    }
  }
];

// Bluetooth Hack Game Frames
const BLUETOOTH_FRAMES = [
  {
    id: 1,
    titulo: "APROXIMANDO DO ALVO",
    descricao: "Você está dirigindo atrás de um carro de luxo na estrada...",
    instrucao: "Mantenha distância de 15 metros",
    visual: "driving",
    acao: "APROXIMAR →"
  },
  {
    id: 2,
    titulo: "ATIVANDO JAMMER",
    descricao: "Ligue o Jammer de frequência para escanear dispositivos...",
    instrucao: "Pressione para ativar o Jammer",
    visual: "jammer",
    acao: "📡 ATIVAR JAMMER"
  },
  {
    id: 3,
    titulo: "ESCANEANDO BLUETOOTH",
    descricao: "Procurando dispositivos Bluetooth no veículo alvo...",
    instrucao: "Aguarde a varredura completar",
    visual: "scanning",
    acao: null,
    autoAdvance: 3000
  },
  {
    id: 4,
    titulo: "DISPOSITIVO ENCONTRADO",
    descricao: "BMW-AUDIO-X7 detectado! Sinal forte.",
    instrucao: "Selecione a frequência de pareamento",
    visual: "device",
    frequencias: ["2.402 GHz", "2.426 GHz", "2.480 GHz"],
    acaoFreq: true
  },
  {
    id: 5,
    titulo: "PAREANDO...",
    descricao: "Estabelecendo conexão com o sistema de áudio...",
    instrucao: "Pareamento em progresso",
    visual: "pairing",
    acao: null,
    autoAdvance: 2500
  },
  {
    id: 6,
    titulo: "CONEXÃO ESTABELECIDA!",
    descricao: "Você tem controle total do áudio do veículo!",
    instrucao: "Escolha a mensagem para transmitir:",
    visual: "connected",
    audioSelect: true
  },
  {
    id: 7,
    titulo: "TRANSMITINDO ÁUDIO...",
    descricao: "Sua mensagem está tocando no carro dele...",
    instrucao: "O alvo está ouvindo...",
    visual: "transmitting",
    acao: null,
    autoAdvance: 3000
  },
  {
    id: 8,
    titulo: "ALVO PAROU!",
    descricao: "O carro de luxo encostou no acostamento!",
    instrucao: "Ele desceu e está olhando confuso...",
    visual: "stopped",
    acao: "VER RESULTADO →"
  },
  {
    id: 9,
    titulo: "🎉 OPERAÇÃO SUCESSO!",
    descricao: "5 mulheres saem do seu carro e entram no carro dele pelas portas traseiras!",
    instrucao: "Ele fica na rua olhando pro seu carro sem entender nada...",
    visual: "success",
    final: true
  }
];

// ============ BLUETOOTH GAME COMPONENT ============
const BluetoothGame = ({ onComplete, onBack, bonusMultiplier, showArrow }) => {
  const [frame, setFrame] = useState(0);
  const [selectedFreq, setSelectedFreq] = useState(null);
  const [selectedAudio, setSelectedAudio] = useState(null);
  const [scanning, setScanning] = useState(false);
  const [scanProgress, setScanProgress] = useState(0);
  const [showResult, setShowResult] = useState(false);

  const currentFrame = BLUETOOTH_FRAMES[frame];
  const selectedAudioData = AUDIO_OPTIONS.find(a => a.id === selectedAudio);

  useEffect(() => {
    Analytics.track('bluetooth_game', { frame: frame + 1, audioChoice: selectedAudio });
  }, [frame, selectedAudio]);

  // Auto advance for certain frames
  useEffect(() => {
    if (currentFrame.autoAdvance) {
      if (currentFrame.visual === 'scanning') {
        setScanning(true);
        const interval = setInterval(() => {
          setScanProgress(prev => {
            if (prev >= 100) {
              clearInterval(interval);
              setTimeout(() => {
                setFrame(frame + 1);
                setScanProgress(0);
                setScanning(false);
              }, 500);
              return 100;
            }
            return prev + 5;
          });
        }, 150);
        return () => clearInterval(interval);
      } else if (currentFrame.visual === 'transmitting') {
        // After transmitting, show the result based on audio choice
        const timer = setTimeout(() => {
          setShowResult(true);
        }, currentFrame.autoAdvance);
        return () => clearTimeout(timer);
      } else {
        const timer = setTimeout(() => setFrame(frame + 1), currentFrame.autoAdvance);
        return () => clearTimeout(timer);
      }
    }
  }, [frame, currentFrame]);

  const handleNext = () => {
    if (currentFrame.final || showResult) {
      onComplete();
    } else {
      setFrame(frame + 1);
    }
  };

  const handleFreqSelect = (freq) => {
    setSelectedFreq(freq);
    setTimeout(() => setFrame(frame + 1), 500);
  };

  const handleAudioSelect = (audioId) => {
    setSelectedAudio(audioId);
    setTimeout(() => setFrame(frame + 1), 500);
  };

  return (
    <div className="bluetooth-game">
      {/* Show custom result screen based on audio choice */}
      {showResult && selectedAudioData ? (
        <div className="result-screen">
          {/* Imagem do resultado final */}
          <div className="result-image-container">
            <img src={RESULTADO_IMG} alt="Resultado" className="result-final-image" />
            <div className="result-overlay">
              <h2 className="result-title-overlay">{selectedAudioData.resultado.titulo}</h2>
            </div>
          </div>

          <div className="control-panel result-panel">
            <p className="frame-desc">{selectedAudioData.resultado.descricao}</p>

            <div className="final-reward">
              <div className="reward-amount">
                +R${2 * bonusMultiplier},00 CRÉDITO!
                {bonusMultiplier > 1 && <span className="bonus-tag">🔥 {bonusMultiplier}x BÔNUS!</span>}
              </div>
              
              {/* CTA CURSO HACKER MAROMBA */}
              <div className="curso-cta">
                <p className="curso-titulo">🎓 QUER APRENDER MAIS?</p>
                <p className="curso-desc">Curso de Hacker Maromba para Crianças Online</p>
                <a
                  href={`${WHATSAPP_URL}?text=${encodeURIComponent(`Olá! Gostaria de saber mais sobre o CURSO DE HACKER MAROMBA e a MISSÃO SECRETA VIP! 🔥💪`)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-curso-cta"
                  onClick={() => Analytics.track('curso_click', { from: 'bluetooth_game' })}
                >
                  {showArrow && <span className="arrow-indicator">👉</span>}
                  🎮 QUERO O CURSO + MISSÃO VIP
                </a>
              </div>

              <a
                href={`${WHATSAPP_URL}?text=${encodeURIComponent(`Completei a OPERAÇÃO BLUETOOTH e ganhei R$${2 * bonusMultiplier}! Quero usar meu desconto! 💪`)}`}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-wpp-cta"
                onClick={() => Analytics.track('whatsapp_click', { from: 'bluetooth_game', audioChoice: selectedAudio })}
              >
                💬 RESGATAR CRÉDITO NO WHATSAPP
              </a>
              <button className="btn-sec" onClick={onBack}>← Voltar ao Menu</button>
            </div>
          </div>
        </div>
      ) : (
        <>
          {/* PRIMEIRA PESSOA - Visão de dentro do SEU carro */}
          <div className={`cockpit-view ${currentFrame.visual}`}>
            
            {/* Parabrisa - Visão da estrada com carro do amigo */}
            <div className="windshield">
              <div className="sky"></div>
              <div className="road-perspective">
                <div className="road-surface">
                  <div className="road-lines-moving"></div>
                </div>
                {/* Carro do AMIGO na frente - visto de COSTAS */}
                <div className={`friend-car ${currentFrame.visual === 'stopped' ? 'stopped' : ''}`}>
                  <span className="friend-car-label">CARRO DO AMIGO</span>
                  <div className="car-back-view">
                    <div className="car-roof"></div>
                    <div className="car-body-back">
                      <div className="tail-lights">
                        <span className="tail-light left"></span>
                        <span className="tail-light right"></span>
                      </div>
                      <span className="license-plate">X7-BMW</span>
                    </div>
                    <div className="car-wheels-back">
                      <span className="wheel-back"></span>
                      <span className="wheel-back"></span>
                    </div>
                  </div>
                  {frame >= 3 && frame < 8 && (
                    <div className="bluetooth-signal">
                      <span className="bt-wave"></span>
                      <span className="bt-wave"></span>
                      <span className="bt-wave"></span>
                    </div>
                  )}
                </div>
                {/* SEU CARRO VERMELHO - capô visível embaixo */}
                <div className="your-car-hood">
                  <div className="hood-surface"></div>
                  <span className="your-car-label-hood">SEU CARRO</span>
                </div>
              </div>
            </div>

            {/* Painel do SEU carro */}
            <div className="car-dashboard">
              {/* Velocímetro */}
              <div className="speedometer-gauge">
                <div className="speed-display">
                  <span className="speed-num">{currentFrame.visual === 'driving' ? '80' : currentFrame.visual === 'stopped' ? '0' : '45'}</span>
                  <span className="speed-kmh">km/h</span>
                </div>
              </div>

              {/* JAMMER no painel central */}
              <div className="jammer-device">
                <div className="jammer-screen">
                  <span className="jammer-label">JAMMER RF</span>
                  <span className={`jammer-status-light ${frame >= 2 ? 'active' : ''}`}></span>
                  <span className="jammer-freq">{frame >= 2 ? '2.4 GHz' : 'OFF'}</span>
                  {frame >= 3 && <span className="jammer-signal">▁▂▃▅▆▇ -32dBm</span>}
                </div>
              </div>

              {/* Volante */}
              <div className="steering-wheel-real">
                <div className="wheel-outer">
                  <div className="wheel-inner">
                    <span className="wheel-logo">M</span>
                  </div>
                </div>
                <span className="your-hands">🤲</span>
              </div>
            </div>
          </div>

          {/* Control Panel */}
          <div className="control-panel">
            <div className="frame-indicator">
              ETAPA {frame + 1}/{BLUETOOTH_FRAMES.length}
            </div>

            <h2 className="frame-title">{currentFrame.titulo}</h2>
            <p className="frame-desc">{currentFrame.descricao}</p>
            <p className="frame-instruction">➡️ {currentFrame.instrucao}</p>

            {/* Scanning Progress */}
            {currentFrame.visual === 'scanning' && (
              <div className="scan-progress">
                <div className="scan-bar">
                  <div className="scan-fill" style={{ width: `${scanProgress}%` }}></div>
                </div>
                <span>{scanProgress}%</span>
              </div>
            )}

            {/* Frequency Selection */}
            {currentFrame.acaoFreq && (
              <div className="freq-options">
                {currentFrame.frequencias.map((freq, i) => (
                  <button
                    key={i}
                    className={`freq-btn ${selectedFreq === freq ? 'selected' : ''}`}
                    onClick={() => handleFreqSelect(freq)}
                  >
                    📶 {freq}
                  </button>
                ))}
              </div>
            )}

            {/* Audio Selection */}
            {currentFrame.audioSelect && (
              <div className="audio-options">
                {AUDIO_OPTIONS.map((opt, index) => (
                  <button
                    key={opt.id}
                    className={`audio-btn ${selectedAudio === opt.id ? 'selected' : ''}`}
                    onClick={() => handleAudioSelect(opt.id)}
                  >
                    {showArrow && index === 0 && <span className="red-arrow">➤</span>}
                    <span className="audio-icon">{opt.icon}</span>
                    <span className="audio-name">{opt.nome}</span>
                    <span className="audio-text">"{opt.texto}"</span>
                  </button>
                ))}
              </div>
            )}

            {/* Action Button with arrow */}
            {currentFrame.acao && (
              <div className="action-container">
                {showArrow && <span className="red-arrow-down">🔻</span>}
                <button className="action-btn glow-btn" onClick={handleNext}>
                  {currentFrame.acao}
                </button>
              </div>
            )}

            {/* Final Screen (fallback if no audio selected) */}
            {currentFrame.final && !showResult && (
              <div className="final-reward">
                <div className="reward-amount">
                  +R${2 * bonusMultiplier},00 CRÉDITO!
                  {bonusMultiplier > 1 && <span className="bonus-tag">🔥 {bonusMultiplier}x BÔNUS!</span>}
                </div>
                <p>Use seu desconto em Suplementos!</p>
                <a
                  href={`${WHATSAPP_URL}?text=${encodeURIComponent(`Completei a OPERAÇÃO BLUETOOTH e ganhei R$${2 * bonusMultiplier}! Quero usar meu desconto! 💪`)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-wpp-cta"
                  onClick={() => Analytics.track('whatsapp_click', { from: 'bluetooth_game' })}
                >
                  💬 RESGATAR NO WHATSAPP
                </a>
                <button className="btn-sec" onClick={onBack}>← Voltar ao Menu</button>
              </div>
            )}

            {/* Back Button */}
            {!currentFrame.final && frame === 0 && (
              <button className="btn-back-small" onClick={onBack}>← Voltar</button>
            )}
          </div>
        </>
      )}
    </div>
  );
};

// ============ MAIN MENU ============
const MainMenu = ({ onSelectGame, creditos, xp, bonusActive, timeOnSite }) => {
  useEffect(() => {
    Analytics.track('page_view');
  }, []);

  return (
    <div className="main-menu">
      <img src={LOGO_URL} alt="Logo" className="logo-pulse" />
      <h1 className="titulo-glow">MILÍCIA DIGITAL</h1>
      <p className="sub">Suplementos Mais Baratos</p>

      <div className="hero-card">
        <img src={MASCOT_URL} alt="Maromba" className="hero-img" />
        <div>
          <span className="tag-yellow">MOTORISTA ANÔNIMO</span>
          <h2>O MAROMBA</h2>
          <p>📍 Zona Verde</p>
        </div>
      </div>

      <div className="stats-row">
        <div className="stat-box">
          <span className="stat-val">R${creditos}</span>
          <span className="stat-lbl">Crédito</span>
        </div>
        <div className="stat-box">
          <span className="stat-val">{xp}</span>
          <span className="stat-lbl">XP</span>
        </div>
        <div className="stat-box">
          <span className="stat-val">{timeOnSite}s</span>
          <span className="stat-lbl">Tempo</span>
        </div>
      </div>

      <div className="game-options">
        <button className="game-card new" onClick={() => onSelectGame('bluetooth')}>
          <span className="game-icon">🚗</span>
          <span className="game-title">OPERAÇÃO BLUETOOTH</span>
          <span className="game-desc">Hackeie o carro de luxo</span>
          <span className="game-reward">+R$2,00 {bonusActive && '🔥 2x BÔNUS!'}</span>
          {bonusActive && <span className="bonus-badge">2x</span>}
        </button>

        <button className="game-card" onClick={() => onSelectGame('classic')}>
          <span className="game-icon">🎮</span>
          <span className="game-title">MISSÕES CLÁSSICAS</span>
          <span className="game-desc">5 operações de hacking</span>
          <span className="game-reward">+R$1,00 por fase</span>
        </button>
      </div>

      {bonusActive && (
        <div className="bonus-alert">
          🔥 BÔNUS 2x ATIVO! Complete a Operação Bluetooth agora!
        </div>
      )}

      <div className="produtos-preview">
        <p>💉 Testosterona • Deca • Trembolona</p>
        <p>💊 Oxandrolona • Stanozolol • Dianabol</p>
      </div>

      <a href={LOJA_URL} target="_blank" rel="noopener noreferrer" className="btn-loja-link">
        🛒 Visitar Loja
      </a>
    </div>
  );
};

// ============ CLASSIC GAME (simplified) ============
const ClassicGame = ({ onComplete, onBack, creditos }) => {
  const [missao, setMissao] = useState(0);
  const [passo, setPasso] = useState(0);
  const [xpGanho, setXpGanho] = useState(0);

  const MISSOES = [
    { titulo: "PRESENTE GREGO", passos: ["Hackear iPhone", "Instalar vírus", "Entregar"] },
    { titulo: "INTERNET POPULAR", passos: ["Subir na torre", "Configurar", "Ativar WiFi"] },
    { titulo: "TV HACKEADA", passos: ["Interceptar", "Capturar senha", "Transmitir"] },
    { titulo: "CAFÉZINHO", passos: ["Preparar café", "Acessar sistema", "Escapar"] },
    { titulo: "JUSTIÇA DIGITAL", passos: ["Instalar spy", "Gravar tela", "Expor"] }
  ];

  const completarPasso = () => {
    setXpGanho(xpGanho + 25);
    Analytics.track('step_complete', { missao: missao + 1, passo: passo + 1 });

    if (passo < MISSOES[missao].passos.length - 1) {
      setPasso(passo + 1);
    } else {
      Analytics.track('mission_complete', { missao: missao + 1 });
      if (missao < MISSOES.length - 1) {
        setMissao(missao + 1);
        setPasso(0);
      } else {
        onComplete(xpGanho + 100);
      }
    }
  };

  return (
    <div className="classic-game">
      <div className="classic-header">
        <button className="btn-back" onClick={onBack}>←</button>
        <h2>OP-{missao + 1}: {MISSOES[missao].titulo}</h2>
      </div>

      <div className="classic-progress">
        Missão {missao + 1}/5 • Passo {passo + 1}/{MISSOES[missao].passos.length}
      </div>

      <div className="classic-step">
        <h3>{MISSOES[missao].passos[passo]}</h3>
        <button className="action-btn glow-btn" onClick={completarPasso}>
          ✓ COMPLETAR
        </button>
      </div>

      <div className="classic-xp">XP Ganho: +{xpGanho}</div>
    </div>
  );
};

// ============ ADMIN PANEL ============
const AdminPanel = ({ onLogout }) => {
  const [stats, setStats] = useState(Analytics.getSummary());
  const [events, setEvents] = useState(Analytics.getAll());

  const refresh = () => { setStats(Analytics.getSummary()); setEvents(Analytics.getAll()); };

  return (
    <div className="admin-panel">
      <div className="admin-header">
        <h1>📊 ADMIN</h1>
        <div>
          <button onClick={refresh} className="admin-btn">🔄</button>
          <button onClick={onLogout} className="admin-btn logout">Sair</button>
        </div>
      </div>

      <div className="admin-stats">
        <div className="stat-card"><div className="stat-value">{stats.total_visits}</div><div className="stat-label">Visitas</div></div>
        <div className="stat-card"><div className="stat-value">{stats.play_clicks}</div><div className="stat-label">Jogou</div></div>
        <div className="stat-card"><div className="stat-value">{stats.bluetooth_game}</div><div className="stat-label">Bluetooth</div></div>
        <div className="stat-card highlight"><div className="stat-value">{stats.whatsapp_clicks}</div><div className="stat-label">WhatsApp</div></div>
      </div>

      <div className="admin-section">
        <h2>📋 Eventos ({events.length})</h2>
        <div className="events-list">
          {events.slice(-15).reverse().map((e, i) => (
            <div key={i} className="event-item">
              <span className={`event-type ${e.event}`}>{e.event}</span>
              <span className="event-time">{new Date(e.timestamp).toLocaleTimeString('pt-BR')}</span>
            </div>
          ))}
        </div>
        <button onClick={() => { Analytics.clear(); refresh(); }} className="admin-btn danger">🗑️ Limpar</button>
      </div>
    </div>
  );
};

// Admin Login
const AdminLogin = ({ onLogin }) => {
  const [user, setUser] = useState('');
  const [pass, setPass] = useState('');
  const [error, setError] = useState('');

  const handleLogin = (e) => {
    e.preventDefault();
    if (user === ADMIN_USER && pass === ADMIN_PASS) onLogin();
    else setError('Credenciais inválidas');
  };

  return (
    <div className="admin-login">
      <div className="login-box">
        <h1>🔐 ADMIN</h1>
        <form onSubmit={handleLogin}>
          <input type="text" placeholder="Usuário" value={user} onChange={e => setUser(e.target.value)} />
          <input type="password" placeholder="Senha" value={pass} onChange={e => setPass(e.target.value)} />
          {error && <p className="error">{error}</p>}
          <button type="submit">ENTRAR</button>
        </form>
      </div>
    </div>
  );
};

// WhatsApp Float
const WhatsAppBtn = ({ creditos }) => (
  <a
    href={`${WHATSAPP_URL}?text=${encodeURIComponent(creditos > 0 ? `Tenho R$${creditos} de desconto do Milícia Digital! 💪` : `Vim do Milícia Digital! 💪`)}`}
    target="_blank"
    rel="noopener noreferrer"
    className="whatsapp-float"
    onClick={() => Analytics.track('whatsapp_click', { creditos })}
  >
    <span className="wa-icon">💬</span>
    {creditos > 0 && <span className="wa-badge">R${creditos}</span>}
  </a>
);

// ============ MAIN APP ============
function App() {
  const [page, setPage] = useState(() => window.location.hash === '#admin' ? 'admin' : 'game');
  const [adminAuth, setAdminAuth] = useState(false);
  const [currentGame, setCurrentGame] = useState(null);
  const [creditos, setCreditos] = useState(() => parseInt(localStorage.getItem('md_cred') || '0'));
  const [xp, setXP] = useState(() => parseInt(localStorage.getItem('md_xp') || '0'));
  const [bonusActive, setBonusActive] = useState(false);
  const [timeOnSite, setTimeOnSite] = useState(0);
  const [redirected, setRedirected] = useState(false);
  const [musicPlaying, setMusicPlaying] = useState(false);
  const [showArrow, setShowArrow] = useState(false);
  const videoRef = useRef(null);

  // Background music from MP4 (video hidden, audio only) - autoplay on first interaction
  useEffect(() => {
    // Create hidden video element for audio
    const video = document.createElement('video');
    video.src = BG_MUSIC_URL;
    video.loop = true;
    video.volume = 0.3;
    video.playsInline = true;
    video.muted = false;
    video.style.display = 'none';
    document.body.appendChild(video);
    videoRef.current = video;

    // Function to try playing
    const tryPlay = () => {
      if (videoRef.current && !musicPlaying) {
        // First try muted (browsers allow muted autoplay)
        videoRef.current.muted = true;
        videoRef.current.play().then(() => {
          // Once playing, unmute
          setTimeout(() => {
            if (videoRef.current) {
              videoRef.current.muted = false;
              setMusicPlaying(true);
            }
          }, 100);
        }).catch(() => {
          // Try unmuted on interaction
          videoRef.current.muted = false;
          videoRef.current.play().then(() => {
            setMusicPlaying(true);
          }).catch(() => {});
        });
      }
    };

    // Try on ANY user interaction
    const startMusic = () => {
      if (videoRef.current && !musicPlaying) {
        videoRef.current.muted = false;
        videoRef.current.play().then(() => {
          setMusicPlaying(true);
        }).catch(() => {});
      }
    };

    document.addEventListener('click', startMusic);
    document.addEventListener('touchstart', startMusic);
    document.addEventListener('touchend', startMusic);
    document.addEventListener('keydown', startMusic);
    document.addEventListener('scroll', startMusic);

    // Try immediately
    tryPlay();

    return () => {
      document.removeEventListener('click', startMusic);
      document.removeEventListener('touchstart', startMusic);
      document.removeEventListener('touchend', startMusic);
      document.removeEventListener('keydown', startMusic);
      document.removeEventListener('scroll', startMusic);
      if (videoRef.current) {
        videoRef.current.pause();
        videoRef.current.remove();
      }
    };
  }, [musicPlaying]);

  // Show arrow after 5 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowArrow(true);
    }, 5000);
    return () => clearTimeout(timer);
  }, []);

  // Time tracker - REDIRECT ALWAYS AT 33 SECONDS
  useEffect(() => {
    const startTime = Date.now();
    const interval = setInterval(() => {
      const elapsed = Math.floor((Date.now() - startTime) / 1000);
      setTimeOnSite(elapsed);

      // Activate bonus at 10 seconds
      if (elapsed >= 10 && !bonusActive) {
        setBonusActive(true);
      }

      // Redirect at 33 seconds - ALWAYS, NO EXCEPTIONS
      if (elapsed >= 33 && !redirected) {
        setRedirected(true);
        window.location.href = LOJA_URL;
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [bonusActive, redirected]);

  // Toggle music
  const toggleMusic = () => {
    if (videoRef.current) {
      if (musicPlaying) {
        videoRef.current.pause();
        setMusicPlaying(false);
      } else {
        videoRef.current.play();
        setMusicPlaying(true);
      }
    }
  };

  // Hash change
  useEffect(() => {
    const handleHash = () => setPage(window.location.hash === '#admin' ? 'admin' : 'game');
    window.addEventListener('hashchange', handleHash);
    return () => window.removeEventListener('hashchange', handleHash);
  }, []);

  // Save state
  useEffect(() => {
    localStorage.setItem('md_cred', creditos.toString());
    localStorage.setItem('md_xp', xp.toString());
  }, [creditos, xp]);

  const handleSelectGame = (game) => {
    Analytics.track('click_play', { game });
    setCurrentGame(game);
  };

  const handleBluetoothComplete = () => {
    const bonus = bonusActive ? 2 : 1;
    setCreditos(prev => Math.min(prev + (2 * bonus), 10));
    setXP(prev => prev + 200);
    setCurrentGame(null);
  };

  const handleClassicComplete = (xpGanho) => {
    setCreditos(prev => Math.min(prev + 5, 10));
    setXP(prev => prev + xpGanho);
    setCurrentGame(null);
  };

  // Admin
  if (page === 'admin') {
    if (!adminAuth) return <AdminLogin onLogin={() => setAdminAuth(true)} />;
    return <AdminPanel onLogout={() => { setAdminAuth(false); window.location.hash = ''; }} />;
  }

  // Game
  return (
    <div className="app">
      <div className="bg-gradient" />
      <div className="scanlines" />

      {/* Music toggle button with blue arrow */}
      <div className="music-toggle-container">
        {!musicPlaying && (
          <div className="sound-arrow-container">
            <span className="blue-arrow-sound">➤</span>
            <span className="sound-hint">7</span>
          </div>
        )}
        <button className="music-toggle" onClick={toggleMusic}>
          {musicPlaying ? '🔊' : '🔇'}
        </button>
      </div>

      {/* Countdown timer */}
      <div className="redirect-timer">
        ⏱️ {Math.max(0, 33 - timeOnSite)}s
      </div>

      <div className="content">
        {!currentGame && (
          <MainMenu
            onSelectGame={handleSelectGame}
            creditos={creditos}
            xp={xp}
            bonusActive={bonusActive}
            timeOnSite={timeOnSite}
            showArrow={showArrow}
          />
        )}

        {currentGame === 'bluetooth' && (
          <BluetoothGame
            onComplete={handleBluetoothComplete}
            onBack={() => setCurrentGame(null)}
            bonusMultiplier={bonusActive ? 2 : 1}
            showArrow={showArrow}
          />
        )}

        {currentGame === 'classic' && (
          <ClassicGame
            onComplete={handleClassicComplete}
            onBack={() => setCurrentGame(null)}
            creditos={creditos}
          />
        )}
      </div>

      <WhatsAppBtn creditos={creditos} />
    </div>
  );
}

export default App;
